module.exports = __webpack_public_path__ + "img/trends_11.c1508e54.jpg";